import { put } from 'redux-saga/effects';
import { WebSocketMessage } from '../../../models/WebSocket';
import { updatePrioHealthHighestErrorLevel } from '../actions/prioHealthHighestErrorLevel';
import { PrioHealthErrorLevel } from '../../../models/Zendesk';

export function* handleHighestErrorLevelNotificationMessage(
  message: WebSocketMessage
) {
  const highestErrorLevel = message.type as PrioHealthErrorLevel;
  if (highestErrorLevel) {
    yield put(updatePrioHealthHighestErrorLevel(highestErrorLevel));
  }
}
